/**
 * Integration environment configuration
 */
import { userLocale } from '../app/models/locale.model';

export const environment = {
  get locale() {
    return userLocale || 'en-WW';
  },
  lambdaEndpoint: 'https://api.unsubscribe-test.porsche.com/',
  env: 'preview'
};
